export default "__VITE_ASSET__6Q_pomW9__"